import { AlertProps } from '@mui/material';
import { createCtx } from 'v2/core/utils/createCtx';
import { LeftOffset } from './utils/types';

export enum ToastNotificationType {
  DefaultNotification = 'default-notification',
  InfoCard = 'info-card',
}

export interface NotificationProps extends Omit<AlertProps, 'severity'> {
  notificationType?: ToastNotificationType;
  isClosable?: boolean;
  timeout?: number;
  severity?: AlertProps['severity'] | 'custom';
  title?: string;
  zIndex?: number;
  autoClose?: boolean;
  leftOffset?: LeftOffset;
  icon?: React.ReactNode;
}

export interface ShowNotificationOptions {
  contentComponent:
    | (({ notificationID }: { notificationID: string }) => JSX.Element)
    | string;
  props: NotificationProps;
}

export interface NotificationContextType {
  showNotification: (options: ShowNotificationOptions) => string;
  /**
   * A function that returns the notification id
   */
  showSuccessNotification: (options: ShowNotificationOptions) => string;
  showErrorNotification: (options: ShowNotificationOptions) => string;
  hideNotification: (notificationId: string) => void;
}

export const [useNotificationContext, NotificationContextProvider] =
  createCtx<NotificationContextType>();
